import { render, staticRenderFns } from "./kaifapiao.vue?vue&type=template&id=c9c278d2&scoped=true"
import script from "./kaifapiao.vue?vue&type=script&lang=js"
export * from "./kaifapiao.vue?vue&type=script&lang=js"
import style0 from "./kaifapiao.vue?vue&type=style&index=0&id=c9c278d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c278d2",
  null
  
)

export default component.exports